var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditDocument = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 36.6666V31.5416L32.5417 22.375C32.7917 22.125 33.0694 21.9444 33.375 21.8333C33.6806 21.7222 33.9861 21.6666 34.2917 21.6666C34.625 21.6666 34.9444 21.7291 35.25 21.8541C35.5556 21.9791 35.8333 22.1666 36.0833 22.4166L37.625 23.9583C37.8472 24.2083 38.0208 24.4861 38.1458 24.7916C38.2708 25.0972 38.3333 25.4028 38.3333 25.7083C38.3333 26.0139 38.2778 26.3264 38.1667 26.6458C38.0556 26.9653 37.875 27.25 37.625 27.5L28.4583 36.6666H23.3333ZM25.8333 34.1666H27.4167L32.4583 29.0833L31.7083 28.2916L30.9167 27.5416L25.8333 32.5833V34.1666ZM10 36.6666C9.08333 36.6666 8.29861 36.3403 7.64583 35.6875C6.99306 35.0347 6.66667 34.25 6.66667 33.3333V6.66665C6.66667 5.74998 6.99306 4.96526 7.64583 4.31248C8.29861 3.6597 9.08333 3.33331 10 3.33331H23.3333L33.3333 13.3333V18.3333H30V15H21.6667V6.66665H10V33.3333H20V36.6666H10ZM31.7083 28.2916L30.9167 27.5416L32.4583 29.0833L31.7083 28.2916Z",
    fill: "#C90000"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit_document.916d7da6.svg";
export { ForwardRef as ReactComponent };